<template>
  <v-form v-model="valid" ref="mainForm">
    <MemoLive code="commentaires" v-model="sasAccreditation.commentairesSurLaDemande" :live="liveSasAccreditation(24616)" />
    <FileInput
      code="document_complementaire1"
      :file="sasAccreditation.documentComplementaire1"
      :live="liveSasAccreditation(24631)"
      :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
    />
    <FileInput
      code="document_complementaire2"
      :file="sasAccreditation.documentComplementaire2"
      :live="liveSasAccreditation(24632)"
      :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
    />
  </v-form>
</template>

<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasAccreditation() {
      return this.sas.sasAccreditation
    }
  },
  methods: {
    liveSasAccreditation(cle) {
      return { endpoint: "sas-accreditations", cle: cle, fileId: this.sasAccreditation.id }
    }
  }
}
</script>

<style></style>
